<div id="layout-wrapper">

  <app-topbar (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()">
  </app-topbar>

  <app-notification-banner></app-notification-banner>

  <!-- Sits above the trial banner: a support session is the more urgent thing
       to know about, and inside one the trial banner is the customer's, not yours. -->
  <app-impersonation-banner></app-impersonation-banner>

  <app-trial-banner></app-trial-banner>

  <app-sidebar></app-sidebar>

  <div class="main-content" [class.has-subscription-banner]="showBanner$ | async">
    <div class="page-content">
      <!-- Sits in normal flow rather than fixed, so it stacks below the fixed
           trial and impersonation banners instead of overlapping them. -->
      <div class="container-fluid">
        <app-service-billing-banner></app-service-billing-banner>
      </div>

      <!-- content -->
      <router-outlet></router-outlet>
    </div>

    <!-- footer -->
    <app-footer></app-footer>
  </div>
</div>

<app-rightsidebar></app-rightsidebar>